import { WidthFull } from "@mui/icons-material";
import { LuSearch } from "@/Components/Icons/Icons.jsx";
export default {
  row1 : [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "exportControlType",
          label: "Type",
          component: "dropdown",
          endIconName: "LuChevronDown",
           options: [
            { label: "Fumigation Control", value: "Fumigation Control" },
            { label: "Preshipment Inspection Control", value: "Preshipment Inspection Control" },
            { label: "Previous Test Report", value: "Previous Test Report" },
            { label: "Probable Inspection Window Request", value: "Probable Inspection Window Request" },
            { label: "Vaccination Control - General", value: "Vaccination Control - General" },
           
          ],
        },
        {
          name: "exportControllocation",
          label: "Location",
          component: "text-field",
        },
      ],
      row2: [
        {
          name: "exportControlStartDate",
          label: "Start Date",
          component: "datetimeselector",
          width:"50%"
        },
        {
          name: "exportControlEndDate",
          label: "End Date",
          component: "datetimeselector",
          width:"50%"
          
        },
      ],

       row3: [
        {
          name: "exportControlResult",
          label: "Result",
          component: "dropdown",
          width:"50%",
          disabled:true,
        },
       
      ],
   
    },
  },
]
};
